import React, {useState} from 'react';
import {Box} from '@mui/material';
import './HotelsList.scss';
import HotelsTable from '../Utils/Table/HotelsTable';
import MoveSelectionModal from '../Utils/Modal/MoveSelectionModal/MoveSelectionModal';
import SearchTableInput from "../../../components/SearchTableInput/SearchTableInput";

const HotelsList = ({
                        mergedHotels,
                        selectedHotelsInThird,
                        setSelectedHotelsInThird,
                        moveHotelsToGroup,
                        selectedGroup,
                        loading,
                        error,
                        showAddModal,
                        setShowAddModal
                    }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const filteredHotels = mergedHotels.filter(group =>
        (group.name && group.name.toLowerCase().includes(searchTerm.toLowerCase())) || 
        (group.id && group.id.toString().toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleCheckboxChange = (hotelIdOrAction, newSelection) => {
        // Bulk update (from header checkbox)
        if (hotelIdOrAction === 'selectAll') {
            setSelectedHotelsInThird(newSelection);
            return;
        }

        // Toggle single hotel
        setSelectedHotelsInThird((prevSelected) =>
            prevSelected.includes(hotelIdOrAction)
                ? prevSelected.filter(id => id !== hotelIdOrAction)
                : [...prevSelected, hotelIdOrAction]
        );
    };


    const handleConfirmMove = async (selectedOption) => {
        try {
            await moveHotelsToGroup(selectedOption);
            setShowAddModal(false);
        } catch (err) {
            console.error(err);
        }
    };
    return (
        <div className="hotels-list">
            <Box className="groupTableHeaderTop">
                <h3>Available Hotels ({filteredHotels.length})</h3>
                <SearchTableInput
                    placeholder={"Search"}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </Box>
            <div className="hotels-table-wrapper">
                <HotelsTable
                    filteredHotels={filteredHotels}
                    selectedHotels={selectedHotelsInThird}
                    handleCheckboxChange={handleCheckboxChange}
                    showGroupName={true}
                    isThirdComponent={true}
                    selectedGroup={selectedGroup}
                   />
            </div>

            {/* Move Selection HotelTable */}
            <MoveSelectionModal
                open={showAddModal}
                onClose={() => setShowAddModal(false)}
                onConfirm={handleConfirmMove}
                groupName={selectedGroup?.name || 'Selected Group'}
                loading={loading}
                error={error}  // Show error from parent
            />
        </div>
    );
};

export default HotelsList;
